import { Component, computed, EventEmitter, Input, Output, Signal, inject } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { BoFormsModule } from '@bo/ng-forms';
import { TransactionCategory } from '../../../../_interfaces/transactions.interface';
import { TransactionsService } from '../../../../pages/management/accounting/transactions/_service/transactions.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-category-select-multi',
  imports: [NgSelectModule, BoFormsModule, NgClass],
  templateUrl: './category-select-multi.component.html',
})
export class CategorySelectMultiComponent {
  protected transactionService = inject(TransactionsService);

  public categoryOptions: Signal<TransactionCategory[]> = computed(() => this.transactionService.categoryOptions());
  @Input() filterLabel: boolean = false;
  @Input() selectedCategories: number[] = [];
  @Output() selectionChanged: EventEmitter<number[]> = new EventEmitter<number[]>();

  changeSelection(): void {
    this.selectionChanged.emit(this.selectedCategories);
  }
}
